module.exports = __webpack_public_path__ + "static/img/status_coupon_coming.65b07f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/status_coupon_coming.png
// module id = t1b4
// module chunks = 1